var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9046 0.503289L10.9994 0.430424C11.2163 0.263726 11.4839 0.183299 11.753 0.202894C12.0221 0.222491 12.2762 0.340936 12.4683 0.53779C12.6606 0.734758 12.7777 0.997013 12.7971 1.27668C12.8162 1.55178 12.7393 1.82422 12.5813 2.04555L7.28618 7.47102C7.0753 7.68246 6.793 7.8 6.5 7.8C6.207 7.8 5.9247 7.68246 5.71382 7.47102C5.7136 7.47079 5.71338 7.47057 5.71315 7.47035L0.418724 2.04555C0.260667 1.82422 0.183777 1.55178 0.20286 1.27668C0.222256 0.997012 0.339428 0.734757 0.531663 0.537789C0.723787 0.340935 0.977893 0.22249 1.24702 0.202893C1.51173 0.183618 1.77493 0.261127 1.98992 0.422331L6.35729 4.87011L6.50043 5.01588L6.64313 4.86967L10.9046 0.503289Z",
    fill: "#3E404D",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.530c6c7434bfd51e77d0746ae3942a27.svg";
export { ForwardRef as ReactComponent };